import * as types from './types';

const initialState = {
  appliedFiltersMarketView: {},
};
export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_APPLIED_FILTERS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
